import { render, staticRenderFns } from "./Condominiums.vue?vue&type=template&id=23111e27&scoped=true&"
import script from "./Condominiums.vue?vue&type=script&lang=js&"
export * from "./Condominiums.vue?vue&type=script&lang=js&"
import style0 from "./Condominiums.vue?vue&type=style&index=0&id=23111e27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23111e27",
  null
  
)

export default component.exports